import React from "react";
import useDeviceInfo from "../hooks/useDeviceInfo"; // Adjust path as needed
import "./Ribbon.css";

import hide_img from '../assets/material_icons/hide.svg';
import more_img from '../assets/material_icons/menufll_400.svg';
import logo_H_img from '../assets/logos/top logo.png';


const Ribbon = ({ showRibbonContent, setShowRibbonContent, setDrawTrigger, children }) => {

  const { deviceType } = useDeviceInfo();

  const toggleRibbon = () => {
    setShowRibbonContent(prev => !prev); 
    setDrawTrigger(prev => !prev); // Toggle the draw trigger

  };

  return (
    <div className={`ribbon_open ${deviceType}`}>
      <div className="top_bar">
        <button className="top_bar_btn" onClick={toggleRibbon}>
          <img src={showRibbonContent? hide_img: more_img }  alt="Toggle Ribbon" />
        </button>
        <img
          className="top_bar_logo"
          src={logo_H_img}
          alt="Logo"
          onClick={() => window.open("https://www.deoSolar.co.za", "_blank")}
        />
        <h1 className="top_bar_title" style ={{fontFamily: "'Open Sans', 'sans-serif", fontWeight:'400', fontSize:'14px', color: "white"}}>| Panel Layout Generator V1.2 |</h1>
      </div>

      <div className={`ribbon_content ${!showRibbonContent ? "closed" : ""}`}>
        {children}
      </div>
    </div>
  );
};

export default Ribbon;